import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React from "react";
import './HintDialog.css';
import templateImage from '../../resources/images/template_image.png';

export class HintDialog extends React.Component<any, any> {
    render() {
        return (
            this.props.show ?
            <Dialog
                    id={"hint-dialog"}
                    open={this.props.show}
                    onClose={this.props.onClose}
                    scroll={"paper"}
                    maxWidth={"xl"}
            >
                <DialogTitle id={"hint-dialog-title"}>Linee guida alla compilazione</DialogTitle>
                <DialogContent id={"hint-dialog-content"}>
                    <DialogContentText
                        tabIndex={-1}
                        id={"hint-dialog-text"}
                    >
                    {
                        ["Il file deve contenere la lista dei prodotti e per ciascuno devono essere",<br/>,"compilati i relativi campi riportati in 4 colonne:Nome prodotto;Descrizione (opzionale);",<br/>,"Prezzo (IVA compresa);Categoria",<br/>,<br/>]
                    }
                    {
                        ["Verranno importati i soli prodotti che hanno il campo \"Nome\" diverso rispetto ai prodotti attualmente",<br/>,"presenti nel catalogo (il controllo non è case sensitive.",<br/>,"Esempio: la parola \"Scarpe\" risulterà identica a \"SCARPE\" o a \"scarpe\")",<br/>,<br/>]
                    }
                    {
                        ["Nel caso in cui siano riportati prodotti uguali a quelli già presenti nel catalogo, non verranno caricati nuovamente",<br/>,"e ne verranno aggiornate le informazioni come riportate nell'excel (nel caso in cui sia presente l'immagine sul prodotto questa rimarrà caricata)",<br/>,<br/>]
                    }
                    {
                        ["Nella compilazione dei campi è necessario rispettare i seguenti formalismi:", <br/>, <br/>]
                    }
                    {
                        [<strong>{"Campo \"Nome prodotto\" presente nella colonna A "}</strong>,<br/>,"- formato generale",<br/>,"- sono ammessi caratteri alfanumerici",<br/>, "- non sono ammessi caratteri speciali ~ ! @ # $ % ^ & * _ - + = \ ` | ( ) { } [ ] : \" ' < > , . ? /",<br/>, "- lunghezza massima 30 caratteri",<br/>,<br/>]
                    }
                    {
                        [<strong>{"Campo \"Descrizione (opzionale)\" presente nella colonna B"}</strong>,<br/>,"- formato generale",<br/>,"- sono ammessi caratteri alfanumerici e speciali",<br/>, "- lunghezza massima 80 caratteri",<br/>,<br/>]
                    }
                    {
                        [<strong>{"Campo \"Prezzo\" presente nella colonna C"}</strong>,<br/>,"- formato generale, numero, valuta, contabilità (suggerito)",<br/>,"- sono ammessi caratteri numerici",<br/>,"non sono ammessi caratteri alfabetici e speciali ~ ! @ # $ % ^ & * _ - + = \ ` | ( ) { } [ ] : \" ' < > , . ? /", <br/>, "- importo massimo € 99.999,99",<br/>,<br/>]
                    }
                    {
                        [<strong>{"Campo \"Categoria\" presente nella colonna D "}</strong>,<br/>,"- campo opzionale (se non valorizzato sarà visualizzato successivamente come \"Senza categoria\")",<br/>,"- formato generale ",<br/>,"- sono ammessi caratteri alfanumerici",<br/>,"	- non sono ammessi caratteri speciali ~ ! @ # $ % ^ & * _ - + = \ ` | ( ) { } [ ] : \" ' < > , . ? /", <br/>,"possono essere inserite più di una categoria, se delimitate dal campo \";\"",<br/>,"- lunghezza massima 32767 caratteri.",<br/>,<br/>]
                    }
                    <img src={templateImage} style={{width: '1100px', paddingBottom: '40px'}}/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={"hint-dialog-actions"}>
                    <Button id={"hint-dialog-button"} onClick={this.props.onClose}>
                        {"OK, CAPITO".toUpperCase()}
                    </Button>
                </DialogActions>
            </Dialog> : null
        )
    }
}